import * as React from "react";
const SvgAgentPaymentIcon = ({ color }) => (
  <svg width={23} height={16} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.5 6h-20m0-1.8v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.02 15 3.58 15 4.7 15h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.98 1 19.42 1 18.3 1H4.7c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C1.5 2.52 1.5 3.08 1.5 4.2Z"
    />
  </svg>
);
export default SvgAgentPaymentIcon;
